/* © CNES */
import * as ol from 'ol';
import React from 'react';
/**
 * Map Context.
 */
const MapContext = React.createContext({ map: new ol.Map() });
export default MapContext;
